import { getBugsnagClient } from './bugsnag';

export function reportError(err: Error, metadata?: any): void {
  console.error(err);

  getBugsnagClient()?.notify(err, (event) => {
    //event.addMetadata()
  });
}

export const handleError = reportError;
